import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import LoginForm from "./components/LoginForm";
import Loading from "../../../components/basics/Loading";
import methods from "../../../services/utility";
import loginImg from "../../../assets/images/img/loginImg.svg"

const Login = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const isUserLogedin = methods.checkUserLogin();

  useEffect(() => {
    if (isUserLogedin) {
      navigate(methods.routeAfterLogin());
    }
    setLoading(false);
  }, [navigate, isUserLogedin]);

  const renderLoginImage = () => {
    return (
      <div className="ellipse">
        <img src={loginImg} alt="loginImage" className="image-fluid" />
      </div>
    )
  };

  return (
    <div className="container-fluid">
      {loading && <Loading />}
      <div className="row vh-100">
        <div className="col-lg-4 col-md-6 position-relative">
          <LoginForm />
        </div>
        <div className="d-none d-xl-block col-lg-8 login-panel">
          <div className="frame ">
            {renderLoginImage()}
            <p className="login-text">به پنل رستومنت خوش آمدید.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;